import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseSupplyData } from './base';

/**
 * @internal
 */
export class ApiSupplyDataBeProfile extends ApiBaseSupplyData {
  @ApiOptions({ channel: 'profiles.getDisplay' })
  getProfiles(commodity: string, code: string) {
    return this.get(`/be/profiles/${commodity}/${code}`);
  }

  @ApiOptions({ channel: 'profiles.putDisplay', requestType: 'raw' })
  editProfiles(commodity: string, code: string, params: ParamsAdapter) {
    return this.put(`/be/profiles/${commodity}/${code}`, params);
  }

  @ApiOptions({ channel: 'profiles.get' })
  getCandidateProfiles(commodity: string, code: string) {
    return this.get(`/be/candidate_profiles/${commodity}/${code}`);
  }
}
